/** Иконки управления просмотрщиком историй (обобщённые, наследуют currentColor). */

export const PauseIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <rect x="6" y="5" width="4" height="14" rx="1" />
    <rect x="14" y="5" width="4" height="14" rx="1" />
  </svg>
)

export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M7 5v14l12-7z" />
  </svg>
)

export const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
)

/** Шеврон в кружке — переход между слайдами. */
export const ChevronIcon = ({ dir }: { dir: 'left' | 'right' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    {dir === 'left' ? <path d="M15 5l-7 7 7 7" /> : <path d="M9 5l7 7-7 7" />}
  </svg>
)

/** Скип (play-треугольник + палка) — перескок между историями. Точный SVG из макета. */
export const SkipIcon = ({ dir }: { dir: 'left' | 'right' }) => (
  <svg viewBox="0 0 36 36" fill="none" aria-hidden>
    <g transform={dir === 'right' ? 'translate(36,0) scale(-1,1)' : undefined}>
      <path
        d="M11.01 14.0295C8.3295 15.7605 8.3295 20.2395 11.01 21.9705L27.195 32.421C29.7975 34.1055 33 31.9155 33 28.452V7.54947C33 4.08447 29.799 1.89597 27.195 3.57747L11.01 14.0295Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path d="M3 7.5V28.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </g>
  </svg>
)
